import Papa from 'papaparse';
import filters from '../../config/admin/filters';

const exportCSVFile = (jsonItems, fileTitle) => {
  const exportedFilename = `${fileTitle}.csv` || 'export.csv';
  const blob = new Blob([jsonItems], { type: 'text/csv;charset=utf-8;' });

  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    const link = document.createElement('a');

    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', exportedFilename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

const getColumns = (excludeColumns = false) => {
  let columns = filters.columns.importUsers;

  if (excludeColumns) {
    columns = columns.filter(column => (column.excludeFromDownload !== true)); // Exclude columns that are not used for the downloaded file
  }

  return columns;
};

const createCSVTemplate = () => {
  const columns = getColumns(true);
  const columnKeys = columns.map(column => column.key);

  let csvContent = 'data:text/csv;charset=utf-8,';
  if (navigator.msSaveBlob) {
    csvContent = '';
  }
  csvContent += [
    columnKeys,
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '');

  const data = encodeURI(csvContent);

  if (navigator.msSaveBlob) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    return navigator.msSaveBlob(blob, 'IEexport.csv');
  }

  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', 'export.csv');
  link.click();

  return true;
};

const csvParseToJson = source => Papa.parse(source, {
  header: true,
  skipEmptyLines: true,
});

export { exportCSVFile, createCSVTemplate, csvParseToJson };



// WEBPACK FOOTER //
// ./src/services/csvHandlers.js